<section *ngIf="isAuthenticated()" style="height: 100vh;">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</section>

<div *ngIf="!isAuthenticated()" class="container" style="width: 100%;height: 100%; text-align: center; align-content: center;">
	<h2 class="h1">Validating Credentials ...</h2>
</div>